/**
 * @generated SignedSource<<89a6db9f9e55d1ba7f52eb1495d9368a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_viewer" | "PdpRespTradeIconBubbles_viewer">;
  readonly " $fragmentType": "PdpRespIconBubblesWrapper_viewer";
};
export type PdpRespIconBubblesWrapper_viewer$key = {
  readonly " $data"?: PdpRespIconBubblesWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubblesWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubblesWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_viewer"
    },
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespTradeIconBubbles_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "50d384ae4d7efb2d8117904c0184cfaf";

export default node;
